import { render } from "./Packing3dButtons.vue?vue&type=template&id=34de99a7"
import script from "./Packing3dButtons.vue?vue&type=script&lang=js"
export * from "./Packing3dButtons.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mihne\\Desktop\\matrixWork\\individual\\datacenter\\printqMatrix\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__